import { HttpParams } from "@angular/common/http";
import { forwardRef, Inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { ACTION_STATUS_ATTACHMENTS } from "../common/endpoints";
import { HttpService } from "./http.service";

@Injectable()
export class ActionStatusAttachmentService {

    constructor(
        @Inject(forwardRef(() => HttpService)) private httpService: HttpService
    ) { }

    uploadAttachment(actionStatusId: string, data: FormData, historical: boolean): Promise<void> {
        const params = new HttpParams().set('historical', historical);
        return firstValueFrom(this.httpService.post<void>(ACTION_STATUS_ATTACHMENTS.replace('{id}', actionStatusId), data, params));
    }

    deleteAttachment(actionStatusId: string, s3Key: string, historical: boolean): Promise<void> {
        let params = new HttpParams().set('s3Key', s3Key).set('historical', historical);
        return firstValueFrom(this.httpService.delete<void>(ACTION_STATUS_ATTACHMENTS.replace('{id}', actionStatusId), null, params));
    }
}